// extracted by mini-css-extract-plugin
module.exports = {"promo-banner-button":"PromoBanner_promo-banner-button__8Z853","promo-banner":"PromoBanner_promo-banner__e4MsM","promo-banner-text":"PromoBanner_promo-banner-text__YjOuU"};